import React from 'react';
import './help.less';

const Helper: React.FC = () => {
    return <div></div>;
};

export default React.memo(Helper);
